import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useAuthContext } from '../context';
import { ClientType } from '../types';
import { OktaClient } from './client';

const Callback = () => {
  const { clients, authInitialized, authError } = useAuthContext();
  const { path } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  useEffect(() => {
    let client: OktaClient;

    switch (path) {
      case 'internal':
        if (!clients[ClientType.OktaInternal]) {
          throw new Error('Internal Okta client not available');
        }
        client = clients[ClientType.OktaInternal];
        break;

      case 'external':
        if (!clients[ClientType.OktaExternal]) {
          throw new Error('External Okta client not available');
        }
        client = clients[ClientType.OktaExternal];
        break;
      default:
        throw new Error('invalid path');
    }

    client.handleRedirect();
  }, [clients, path, authInitialized]);

  useEffect(() => {
    if (authError) {
      enqueueSnackbar(
        "Authentication failed. You can continue, but you're not logged in.",
        {
          variant: 'error',
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          preventDuplicate: true,
          persist: true,
        }
      );
      navigate('/');
    }
  }, [authError, navigate, enqueueSnackbar]);

  return null;
};

export { Callback };
